import Crud from '../views/Paciente/Crud'
import Entity from '../views/Paciente/Add'

let routes = {
    path: '/paciente',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/paciente/add',
            name: 'Novopaciente',
            component: Entity
        },
        {
            path: '/paciente/edit/:id?',
            name: 'Editarpaciente',
            component: Entity
        },
        {
            path: '/paciente',
            name: 'list-paciente',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Pacientes',
                breadcrumb: [
                    {
                        text: 'Pacientes',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
